import React                from "react"
import { CategorySelect }   from './categorySelect'
import { TYPES }            from "../app"

export const Category = (
  { categories,
    categoryRequired,
    workorderState,
    setWorkorderState,
    categoryFields,
    workorderCategory,
  }) => {
  const handleCategoryChange = category => {
    const newCategoryFields  = categoryFields.filter(element => element.categoryId === category.id)
    const newExtraFieldState = workorderState.extraFieldAnswers.filter(element => !element.categoryId)
    // A preventive workorder's duration is the sum of its maintenance tasks.
    const applyDuration      = category.defaultDuration && workorderState.workorderType !== TYPES.preventive

    setWorkorderState({
      categoryId: category.id,
      extraFieldAnswers: newCategoryFields.concat(newExtraFieldState),
      ...(applyDuration ? { predictedDuration: category.defaultDuration } : {})
    })
  }

  if (!categories.length) return null

  return(
    <CategorySelect
      workorderCategory = { workorderCategory }
      categories        = { categories }
      required          = { categoryRequired }
      onSelect          = { handleCategoryChange }
    />
  )
}
